import { getTrendingAuthors } from './models';

import { TrendingAuthor as TrendingAuthorFeature } from '@/features/Landing';

const TrendingAuthor = () => {
  const trendingAuthorsPromise = getTrendingAuthors();

  return (
    <TrendingAuthorFeature trendingAuthorsPromise={trendingAuthorsPromise} />
  );
};

export default TrendingAuthor;
